/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Chat_AskInputs */

const en_start_page_chat_ask = /** @type {(inputs: Start_Page_Chat_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hi! Anything free this week?`)
};

const pl_start_page_chat_ask = /** @type {(inputs: Start_Page_Chat_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hej! Masz coś wolnego w tym tygodniu?`)
};

/**
* | output |
* | --- |
* | "Hi! Anything free this week?" |
*
* @param {Start_Page_Chat_AskInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_chat_ask = /** @type {((inputs?: Start_Page_Chat_AskInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Chat_AskInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_chat_ask(inputs)
	return en_start_page_chat_ask(inputs)
});